import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LocaleProvider } from "@/context/LocaleContext";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import Projects from "@/pages/Projects";
import Impact from "@/pages/Impact";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Gallery from "@/pages/Gallery";
import Partners from "@/pages/Partners";
import Publications from "@/pages/Publications";
import Team from "@/pages/Team";
import Volunteer from "@/pages/Volunteer";
import Donation from "@/pages/Donation";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminNews, AdminGallery, AdminPrograms, AdminPublications, AdminPartners, AdminTeam } from "@/pages/admin/CRUDPages";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSiteSettings from "@/pages/admin/AdminSiteSettings";
import AdminPages from "@/pages/admin/AdminPages";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminDonations from "@/pages/admin/AdminDonations";
import CustomPage from "@/pages/CustomPage";
import { SettingsProvider } from "@/context/SettingsContext";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

import "@/App.css";

const router = createBrowserRouter([
  {
    element: <PublicLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/tentang", element: <About /> },
      { path: "/program", element: <Programs /> },
      { path: "/program/:slug", element: <ProgramDetail /> },
      { path: "/proyek", element: <Projects /> },
      { path: "/impact", element: <Impact /> },
      { path: "/berita", element: <News /> },
      { path: "/berita/:slug", element: <NewsDetail /> },
      { path: "/galeri", element: <Gallery /> },
      { path: "/mitra", element: <Partners /> },
      { path: "/publikasi", element: <Publications /> },
      { path: "/tim", element: <Team /> },
      { path: "/volunteer", element: <Volunteer /> },
      { path: "/donasi", element: <Donation /> },
      { path: "/kontak", element: <Contact /> },
      { path: "/p/:slug", element: <CustomPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  { path: "/admin/login", element: <AdminLogin /> },
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "news", element: <AdminNews /> },
      { path: "gallery", element: <AdminGallery /> },
      { path: "programs", element: <AdminPrograms /> },
      { path: "publications", element: <AdminPublications /> },
      { path: "partners", element: <AdminPartners /> },
      { path: "team", element: <AdminTeam /> },
      { path: "submissions", element: <AdminSubmissions /> },
      { path: "pages", element: <AdminPages /> },
      { path: "donations", element: <AdminDonations /> },
      { path: "users", element: <AdminUsers /> },
      { path: "site-settings", element: <AdminSiteSettings /> },
      { path: "settings", element: <AdminSettings /> },
    ],
  },
]);

function App() {
  return (
    <LocaleProvider>
      <AuthProvider>
        <SettingsProvider>
          <RouterProvider router={router} />
        </SettingsProvider>
      </AuthProvider>
    </LocaleProvider>
  );
}

export default App;
